<wiz-hgroup width="100%" height="100%" verticalAlign='center' horizontalAlign='center' style="padding: 5px;">
  <wiz-image #img width="20px" height="20px" [source]="icon"></wiz-image>
  <wiz-label #lbDesc [wizLabel]="desc" ></wiz-label>
</wiz-hgroup>